<template>
  <AppDialog
    :model-value="open"
    title="A new version is available"
    :max-width="480"
    show-close
    testid="schema-mismatch"
    @update:model-value="onOpenChange"
  >
    <p>{{ SCHEMA_MISMATCH_MESSAGE }}</p>
    <template #actions>
      <v-spacer />
      <v-btn color="error" variant="text" data-testid="schema-mismatch-reload" @click="reloadPage">
        {{ CHUNK_LOAD_ERROR_RELOAD_LABEL }}
      </v-btn>
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import AppDialog from "@/components/common/AppDialog.vue";
import { CHUNK_LOAD_ERROR_RELOAD_LABEL, reloadPage } from "@/components/common/chunkLoadError";
import { SCHEMA_MISMATCH_MESSAGE, schemaMismatchDetected } from "@/graphql/schemaMismatch";

/**
 * Asks a tab running a pre-release bundle to reload (#6497). It opens when
 * `schemaMismatchDetected` latches and, once closed, stays closed for the page
 * load: the latch never clears, so nothing can open it again.
 *
 * The person may close it to copy unsaved text. GraphQL stays refused after
 * that, and each refusal carries the same message.
 */
const dismissed = ref(false);
const open = computed(() => schemaMismatchDetected.value && !dismissed.value);

function onOpenChange(value: boolean): void {
  if (!value) dismissed.value = true;
}
</script>
